import { observer } from 'mobx-react';
import { SearchParameter, SearchParameters } from '../../../../../ListFilter/Types';
import MenuItem from './MenuItem';
import { OwnerOptionsResource } from '..';

interface Props {
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
  searchParameters: SearchParameters;
  ownerOptionsData: OwnerOptionsResource;
}

function MenuItems({ updatingSearchParameters, searchParameters, ownerOptionsData }: Props) {
  return ownerOptionsData.payload.map((option) => (
    <MenuItem
      updatingSearchParameters={updatingSearchParameters}
      searchParameters={searchParameters}
      option={option}
      key={option.value}
    />
  ));
}

export default observer(MenuItems);
